import { PartnerUserCreatePage } from "@/features/rso/pages/partner-user/PartnerUserCreate";
import React from "react";

const MatchUserCreate = () => {
  return <PartnerUserCreatePage />;
};

export default MatchUserCreate;
